import React, { memo, useCallback } from 'react';

import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button, Col, Row, Space, Typography } from 'antd';

import { hideModal } from '@/store/actions/modalsActions';

import Modal from '../Modal';
import { MODALS } from '..';

const ConfirmBid = props => {
  const { onOk, bid } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleClickClose = useCallback(() => {
    dispatch(hideModal(MODALS.ConfirmBid));
  }, [dispatch]);

  const handleClickOk = useCallback(() => {
    if (onOk) {
      onOk(bid);
      dispatch(hideModal(MODALS.ConfirmBid));
    }
  }, [dispatch, onOk, bid]);

  return (
    <Modal name={MODALS.ConfirmBid} width={452}>
      <Row gutter={[0, 24]} justify="center">
        <Row>
          <Typography.Title level={3}>{t('modal.confirm-bid.title')}</Typography.Title>
        </Row>
        <Row>
          <Typography.Text style={{ whiteSpace: 'break-spaces' }}>
            {t('modal.confirm-bid.description', { bid })}
          </Typography.Text>
        </Row>
        <Col span={24}>
          <Row justify="end">
            <Space size="middle">
              <Button shape="round" size="large" onClick={handleClickClose}>
                {t('common.cancel')}
              </Button>
              <Button type="primary" shape="round" size="large" onClick={handleClickOk}>
                {t('modal.confirm-bid.button.yes')}
              </Button>
            </Space>
          </Row>
        </Col>
      </Row>
    </Modal>
  );
};

export default memo(ConfirmBid);
